import Model from '@ember-data/model';
import agreeable from 'garaje/utils/decorators/agreeable';

@agreeable
class Agreeable extends Model {}

export default Agreeable;
